import { render, staticRenderFns } from "./logout-dialog.vue?vue&type=template&id=08f858bf&scoped=true"
import script from "./logout-dialog.vue?vue&type=script&lang=js"
export * from "./logout-dialog.vue?vue&type=script&lang=js"
import style0 from "./logout-dialog.vue?vue&type=style&index=0&id=08f858bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f858bf",
  null
  
)

export default component.exports